import * as React from "react";

import Layout from "../../components/Layout";
import styled from "styled-components";

import { getListOfUsers, User, deleteUser } from "../../api/users";

import { Spinner, TableIconButton, IconButton } from "@hubper/core-ui/elements";

import { Table, TableProvider, columnConfig } from "@hubper/table";

import Confirm from "@hubper/core-ui/modals/Confirm";
import { useModal } from "@hubper/core-ui/hooks";

import { useHistory } from "react-router-dom";

/**
 * Styles
 */

const Main = styled.div`
  width: 100%;
`;

const Top = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

/**
 * Main
 */

const config = columnConfig<User>()
  .string("id")
  .string("name")
  .string("email");

function Users() {
  const [users, setUsers] = React.useState<User[] | null>(null);
  const { showModal } = useModal();
  const history = useHistory();

  React.useEffect(() => {
    getListOfUsers().then(setUsers);
  }, []);

  return (
    <Layout
      bodyStyle={{
        position: "relative",
        display: "flex"
      }}
    >
      <Main>
        <h1 style={{ margin: 0 }}>Users - Overview</h1>

        {!users ? (
          <Spinner />
        ) : (
          <>
            <Top>
              <IconButton
                type="color"
                name="add"
                onClick={() => history.push(`/users/add`)}
              />
            </Top>
            <TableProvider
              t={"" as any}
              columns={config}
              data={users}
              actions={{
                width: 100,
                render: ({ row }) => {
                  return (
                    <>
                      <TableIconButton
                        name="edit"
                        onClick={() => history.push(`/users/${row.id}`)}
                      />
                      <TableIconButton
                        name="delete"
                        onClick={() => {
                          showModal(
                            <Confirm
                              title={`Delete user`}
                              message={
                                <>
                                  Are you shure you want to delete user '
                                  {row.name}'? <br />
                                  This action can't be undone.
                                </>
                              }
                              okLabel="OK"
                              cancelLabel="Cancel"
                              type="delete"
                              onConfirm={async () => {
                                await deleteUser(row.id);

                                setUsers(s => s!.filter(x => x.id !== row.id));
                              }}
                            />
                          );
                        }}
                      />
                    </>
                  );
                }
              }}
            >
              <Table />
            </TableProvider>
          </>
        )}
      </Main>
    </Layout>
  );
}

export default Users;
